import React, { FC } from 'react'
import { Center, Divider, HStack, Typography, VStack, XelaColor } from '@/XelaReact'
import { useDispatch, useSelector } from 'react-redux'
import { motion } from 'framer-motion'
import { router, usePage } from '@inertiajs/react'
import { RootState } from '@/Store'
import { Box, UnstyledButton } from '@mantine/core'
import { toggleHubCommissionSubSidebar } from '@/Store/globalSlice'
import IconFileInvoice from '@/Icons/IconFileInvoice'
import IconDocuments from '@/Icons/IconDocuments'
import { IconChevronLeft } from '@tabler/icons-react'

const HubSubSidebar: FC = () => {
  const page = usePage()
  const dispatch = useDispatch()
  const globalStore = useSelector((state: RootState) => state.global)

  const tabItems = []

  {
    tabItems.push({
      label: 'Invoices',
      route: '/hub/commission/invoices',
      icon: <IconFileInvoice width="16" height="17" />,
    })

    tabItems.push({
      label: 'Summary',
      route: '/hub/commissions',
      icon: <IconDocuments width="16" height="17" />,
    })
  }

  return (
    <motion.div
      className={`${
        globalStore.isHubCommissionSubSidebarOpen ? 'w-60 block' : 'hidden'
      } z-10 absolute bg-white min-h-screen top-0`}
      initial={{ opacity: 0.5, x: 0 }}
      animate={{ opacity: 1, x: globalStore.isSidebarOpen ? 230 : 65 }}
      transition={{ duration: 0.25 }}
    >
      <div>
        <VStack
          bg={XelaColor.White}
          spacing="12px"
          justifyContent="flex-start"
          height="100vh"
          className="shadow py-8 px-4 overflow-auto"
        >
          <HStack justifyContent={globalStore.isHubCommissionSubSidebarOpen ? 'space-between' : 'center'}>
            <VStack spacing="4px">
              <HStack justifyContent={globalStore.isHubCommissionSubSidebarOpen ? 'space-between' : 'center'}>
                <Typography variant={'subheadline'} color={XelaColor.Blue3}>
                  Commissions
                </Typography>
                <UnstyledButton
                  className={'hover:bg-blue-50 p-1 rounded-full ease-in-out delay-50'}
                  onClick={() => {
                    dispatch(toggleHubCommissionSubSidebar(false))
                  }}
                >
                  <IconChevronLeft size={20} />
                </UnstyledButton>
              </HStack>
            </VStack>
          </HStack>
          <Divider variant="dotted" />
          <VStack spacing="8px">
            {tabItems.map((item, index) => (
              <Box
                key={index}
                onClick={() => {
                  dispatch(toggleHubCommissionSubSidebar(!globalStore.isHubCommissionSubSidebarOpen))
                  router.visit(`${item.route}`)
                }}
                style={
                  page.url === item.route
                    ? {
                        padding: '8px',
                        backgroundColor: XelaColor.Blue12,
                        borderRadius: '12px',
                        width: '100%',
                      }
                    : {
                        padding: '8px',
                      }
                }
                className="flex space-x-4 w-full px-2 py-3 cursor-pointer hover:bg-blue-12 rounded-lg"
              >
                <Center width="18px" height="18px" style={{ minWidth: '24px' }}>
                  {item.icon}
                </Center>
                <Box className="flex justify-between w-full">
                  <Typography variant="body-small-bold">{item.label}</Typography>
                </Box>
              </Box>
            ))}
          </VStack>
        </VStack>
      </div>
    </motion.div>
  )
}

export default HubSubSidebar
